import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGetBlogListQuery } from "../../../redux/slices/blogSlice";
import Skeleton from "react-loading-skeleton";
const DagaBlogCard = () => {
  const {
    data: blogList,
    isSuccess: blogListIsSuccess,
    isLoading: blogListIsLoading,
    isError: blogListIsError,
    error: blogListError,
  } = useGetBlogListQuery();
  console.log(
    blogListIsSuccess,
    blogListIsLoading,
    blogListIsError,
    blogListError
  );
  console.log(blogList?.data);
  console.log(blogListError);
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const sortedBlogList = blogList?.data?.slice().sort((a, b) => new Date(b.modified) - new Date(a.modified));

  const naviagte = useNavigate();
  return (
    <div>
      <div className="max-w-screen-xl mx-auto p-5 sm:p-10 md:p-16">
        <div className="grid grid-cols-1 md:grid-cols-3 sm:grid-cols-2 gap-10">
          {sortedBlogList?.map((item, index) => (
            // { blogList.map((item, index) => (
            <div
              key={index}
              className="border-r border-b border-l border-gray-400 border-t lg:border-gray-400 bg-white flex flex-col leading-normal"
            >
              <Link to={`/blog/${item?.name}`}>
                <img
                  src={`https://demoerp.plushvie.in${item?.meta_image}`} // for demo
                  alt="blog poster"
                  className="w-full mb-3 aspect-[3/2] object-contain cursor-pointer"
                />
              </Link>
              <div className="p-2 pt-2">
                <div className="mb-8">
                  {/* <p className="text-sm text-gray-600 flex items-center">
                  <svg
                    className="fill-current text-gray-500 w-3 h-3 mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M4 8V6a6 6 0 1 1 12 0v2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h1zm5 6.73V17h2v-2.27a2 2 0 1 0-2 0zM7 6v2h6V6a3 3 0 0 0-6 0z"></path>
                  </svg>
                  Members only
                </p> */}
                  <p className="mb-2 text-xs">{formatDate(item?.modified)}</p>
                  <Link
                    to={`/blog/${item?.name}`}
                    className="text-gray-900 font-bold text-lg mb-2 hover:underline inline-block"
                  >
                    {item?.title}
                  </Link>
                  <div>
                    <Link className="text-sm uppercase">
                      {item?.blog_category}
                    </Link>
                  </div>
                  <p className="text-gray-700 text-base line-clamp-4 mt-2 text-justify">
                    {item?.content_md}
                  </p>
                  <Link to={`/blog/${item?.name}`} className=" ">
                    <div className="flex flex-row items-center">
                      <p className="text-lg hover:underline">Read more</p>
                      <span className="text-xl">&nbsp;&rarr;</span>
                    </div>
                  </Link>
                </div>
                {/* <div>
                <Link>category</Link>
              </div> */}
                {/* <div className="flex items-center">
                <a href="#">
                  <img
                    className="w-10 h-10 rounded-full mr-4"
                    src="https://tailwindcss.com/img/jonathan.jpg"
                    alt="Avatar of Jonathan Reinink"
                  />
                </a>
                <div className="text-sm">
                  <a
                    href="#"
                    className="text-gray-900 font-semibold leading-none hover:text-indigo-600"
                  >
                    Jonathan Reinink
                  </a>
                  <p className="text-gray-600">Aug 18</p>
                </div>
              </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DagaBlogCard;

export const DagaBlogCardVerticle = () => {
  const {
    data: blogList,
    isSuccess: blogListIsSuccess,
    isLoading: blogListIsLoading,
    isError: blogListIsError,
    error: blogListError,
  } = useGetBlogListQuery();
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const sortedBlogList = blogList?.data?.slice().sort((a, b) => new Date(b.modified) - new Date(a.modified));

  return (
    <div className="w-full lg:w-1/4 m-auto mt-12 max-w-screen-sm">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-1 gap-4 ">
        {/* {!blogListIsSuccess &&
          [{}, {}, {}].map((item, index) => (
            <div
              className="border-r border-b border-l border-gray-400 border-t lg:border-gray-400 bg-white flex flex-col leading-normal"
              key={index}
            >
              <h1>raammm</h1>
              <Skeleton count={12}/>
            </div>
          ))} */}
        {blogListIsSuccess && sortedBlogList?.slice(0,3)?.map((item, index) => (
          <div
            key={index}
            className="border-r border-b border-l border-gray-400 border-t lg:border-gray-400 bg-white flex flex-col leading-normal"
          >
            <Link to={`/blog/${item?.name}`}>
              <img
                src={`https://demoerp.plushvie.in${item?.meta_image}`}
                alt="blog poster"
                className="w-full mb-3 aspect-[3/2] object-contain cursor-pointer"
              />
            </Link>
            <div className="p-2 pt-2">
              <div className="mb-8">
                {/* <p className="text-sm text-gray-600 flex items-center">
                  <svg
                    className="fill-current text-gray-500 w-3 h-3 mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M4 8V6a6 6 0 1 1 12 0v2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h1zm5 6.73V17h2v-2.27a2 2 0 1 0-2 0zM7 6v2h6V6a3 3 0 0 0-6 0z"></path>
                  </svg>
                  Members only
                </p> */}
                <p className="mb-2 text-xs">{formatDate(item?.modified)}</p>
                <Link
                  to={`/blog/${item?.name}`}
                  className="text-gray-900 font-bold text-lg mb-2 hover:underline inline-block"
                >
                  {item?.title}
                </Link>
                <div>
                  <Link className="text-sm uppercase">
                    {item?.blog_category}
                  </Link>
                </div>
                <p className="text-gray-700 text-base line-clamp-4 mt-2 text-justify">
                  {item?.content_md}
                </p>
                <Link to={`/blog/${item?.name}`} className=" ">
                  <div className="flex flex-row items-center">
                    <p className="text-lg hover:underline">Read more</p>
                    <span className="text-xl">&nbsp;&rarr;</span>
                  </div>
                </Link>
              </div>
              {/* <div>
                <Link>category</Link>
              </div> */}
              {/* <div className="flex items-center">
                <a href="#">
                  <img
                    className="w-10 h-10 rounded-full mr-4"
                    src="https://tailwindcss.com/img/jonathan.jpg"
                    alt="Avatar of Jonathan Reinink"
                  />
                </a>
                <div className="text-sm">
                  <a
                    href="#"
                    className="text-gray-900 font-semibold leading-none hover:text-indigo-600"
                  >
                    Jonathan Reinink
                  </a>
                  <p className="text-gray-600">Aug 18</p>
                </div>
              </div> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
